import React from 'react';
import { FormGroup } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';

const ReplyRating = ({ onSubmit, loading, selected, replyId }) => {
  const onSelectValue = (value) => onSubmit(value);
  return (
    <FormGroup className="ticket-rate" check>
      <div className="ticket-help-question">
        <FMessage id="tickets.reply-rate.title" />
      </div>
      <button id={`${replyId}-rate-1`} onClick={() => onSelectValue(1)}>
        1
      </button>
      <button id={`${replyId}-rate-2`} onClick={() => onSelectValue(2)}>
        2
      </button>
      <button id={`${replyId}-rate-3`} onClick={() => onSelectValue(3)}>
        3
      </button>
      <button id={`${replyId}-rate-4`} onClick={() => onSelectValue(4)}>
        4
      </button>
      <button id={`${replyId}-rate-5`} onClick={() => onSelectValue(5)}>
        5
      </button>
    </FormGroup>
  );
};

export default ReplyRating;
